import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand-arrow",
  "use": "expand-arrow-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"expand-arrow\"><path d=\"M329 256c0 5-2 9-5 13L196 397c-4 3-8 5-13 5s-9-2-13-5c-4-4-5-8-5-13V128c0-5 1-9 5-13 4-3 8-5 13-5s9 2 13 5l128 128c3 4 5 8 5 13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol